import Vue from "vue";
import VueRouter, { Route } from "vue-router";
import { routes } from "./routes";
import usuarioModule from "@/store/usuario/UsuarioModule";
import { usuarioStorage } from '@/store/usuario/UsuarioStorage';
import { LoginModel } from "@/models/login/LoginModel";

Vue.use(VueRouter);

const publicRouteNames = ["Login", "RecuperarSenha", "DefinirNovaSenha"];

const router = new VueRouter({
  routes,
});

//:to="{ name: 'AuthHome' }"

router.beforeEach(async (to, from, next) => {
  
  if (window.location.href.includes("sid")) {
    
    const login: LoginModel = {
      username: "",
      password: "",
    };
    
    login.username = localStorage.getItem("accessToken") || "";
    login.password = localStorage.getItem("usuarioPessoaId") || "00";
    const logado = !!usuarioStorage.getData();
    if (!logado) {
      await usuarioModule
      .efetuarLogin(login)
      .then(() => {})
      .catch((err) => {});
    } 
    const hasToken = !!usuarioStorage.getData();
    if (
      !publicRouteNames.find((name) => name == to.name) &&
      !hasToken
    ) {
      try {
        await usuarioModule.checkUser();
        next({ name: to.name || undefined });
      } catch (err) {
        next({ name: "Login" });
      }
    } else {
      if (
        !!publicRouteNames.find((name) => name == to.name) &&
        hasToken
      ) {
        next({ name: "HomePage" });
      } else {
        next();
      }
    }
     
  } else {
    const hasToken = !!usuarioStorage.getData();
    if (
      !publicRouteNames.find((name) => name == to.name) &&
      !hasToken
    ) {
      try {
        await usuarioModule.checkUser();
        next({ name: to.name || undefined });
      } catch (err) {
        next({ name: "Login" });
      }
    } else {
      if (
        !!publicRouteNames.find((name) => name == to.name) &&
        hasToken
      ) {
        next({ name: "HomePage" });
      } else {
        next();
      }
    }
  }  
});

export default router;
